import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dtwin-map-instance",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('CoreMapboxMglMap', {
    ref: "map",
    staticClass: "map",
    attrs: {
      "bearing": _vm.realCamera.bearing,
      "zoom": _vm.realCamera.zoom,
      "center": _vm.realCamera.center
    },
    on: {
      "load": _vm.onMapLoaded,
      "moveend": _vm.updateMarkers,
      "zoomend": _vm.updateMarkers
    }
  }, [_vm._l(_vm.items, function (marker, i) {
    return _c('MglMarker', {
      key: `marker_${i}`,
      attrs: {
        "coordinates": marker.coordinates,
        "title": marker.title,
        "dtId": marker.id,
        "anchor": marker.imageId ? 'center' : 'bottom-left',
        "offset": {
          x: -10,
          y: 0
        }
      },
      on: {
        "click": function ($event) {
          return _vm.markerClicked(marker);
        }
      }
    }, [_c('span', {
      staticStyle: {
        "z-index": "2"
      },
      attrs: {
        "slot": "marker"
      },
      slot: "marker"
    }, [[_c(VIcon, {
      staticClass: "markerPin",
      attrs: {
        "color": marker.color || _vm.color
      }
    }, [_vm._v("\n            fal fa-" + _vm._s(marker.faIcon ? marker.faIcon : 'map-marker-alt') + "\n          ")]), _c('span', {
      staticClass: "markerPinTitle"
    }, [_vm._v(_vm._s(marker.title))])]], 2)]);
  }), _vm._l(_vm.clusters, function (cluster, i) {
    return _c('MglMarker', {
      key: `cluster_${i}`,
      attrs: {
        "coordinates": cluster.center,
        "title": cluster.count,
        "dtId": `cluster_${i}`,
        "anchor": 'center'
      },
      on: {
        "click": function ($event) {
          return _vm.zoomIntoCluster(cluster);
        }
      }
    }, [_c('span', {
      staticStyle: {
        "z-index": "2"
      },
      attrs: {
        "slot": "marker"
      },
      slot: "marker"
    }, [_c('div', {
      staticClass: "clusterMarker",
      style: `background-color: ${_vm.markerColor}`
    }, [_vm._v("\n          " + _vm._s(cluster.count) + "\n        ")])])]);
  }), _c('MglNavigationControl', {
    attrs: {
      "position": "bottom-right"
    }
  }), _c('MglGeolocateControl', {
    attrs: {
      "position": "bottom-right"
    }
  })], 2), _vm.selectedItem.eui ? _c('div', {
    staticClass: "itemDetail",
    staticStyle: {
      "z-index": "6"
    }
  }, [_c('niota-classic-gw-mgmt-map-detail', {
    attrs: {
      "item": _vm.selectedItem,
      "mapmode": true
    },
    on: {
      "cancel": _vm.closePopup
    }
  })], 1) : _vm._e(), _vm._t("bottom")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };